import { storeBed } from "@/store/modules/bed";
import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

class DataBed {
  async postBed(unitID,no,kelasID,pegawaiID,gabung,catatanBed) {
    let dt: any;
    await http.postData(`/bed`, {
      bed_id: unitID,
      kamar: no,
      kelas_id: kelasID,
      pegawai_id: pegawaiID,
      gabung:gabung,
      catatan_bed:catatanBed
      // status: "2"
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Tambah Bed/Kamar")
      });
    return dt;
  }
  
  async getBedByUnit(unitID) {
    let dt: any;
    await http.getDataParam("/bed", {
      params: { bed_id: unitID },
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Bed/Kamar By Unit/Bangsal")
        dt=[]
        storeBed.actClearBed()
      });
    return dt;
  }
  
  async getPasienAll() {
    let dt: any;
    await http.getData("/pasien")
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Pasien")
        dt=[]
        storeBed.actClearBed()
      });
    return dt;
  }
  
  async deleteBed(id,pegawaiID) {
    console.log("iddel= "+pegawaiID)
    let dt: any;
    // await http.deleteDataParam(`/bed/${id}/delete`, {
    //   pegawai_id: pegawaiID,
    // })    
    await http.deleteData(`/bed/${id}/delete/pegawai_id/${pegawaiID}`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Hapus Bed")
      });
    return dt;
  }

  async editBed(id,no,kelasID,statusID,pegawaiID,gabung,catatanBed) {
    let dt: any;
    await http.putData(`/bed/${id}/update`, {
      kamar: no,
      kelas_id: kelasID,
      status_id:statusID,
      pegawai_id: pegawaiID,
      gabung:gabung,
      catatan_bed:catatanBed
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Edit Bed/Kamar")
      });
    return dt;
  }
  
  async getRekapBed() {
    let dt: any;
    await http.getData("/bed-rekap")
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Rekap Bed")
      });
    return dt;
  }
  
  async postBooking(unitID,kelasID,catatan,pegawaiID,rm,identitas) {
    let dt: any;
    await http.postData(`/booking`, {
      bed_id: unitID,
      kelas_id: kelasID,
      catatan:catatan,
      pegawai_id: pegawaiID,
      rm:rm,
      identitas:identitas
      // status: "2"
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Tambah Pemesanan")
      });
    return dt;
  }
  
  async getBooking(unitID,kelasID) {
    let dt: any;
    await http.getDataParam("/booking", {
      params: { 
        bed_id: unitID,
        kelas_id: kelasID, 
      },
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Pemesanan")
      });
    return dt;
  }
  
  async getBookingByRM(rm) {
    console.log("rm:",rm)
    let dt: any;
    await http.getData(`/pasien/${rm}/booking`)
    // await http.getData("/bed-rekap")
      .then(response => {
        console.log("oke")
        dt = response.data;
      })
      .catch(e => {
        console.log("tidak oke")
        dt = e.response
        
        console.log("message: ",e)
        // ErrorAlert.showSnackAlert(e, "Data Booking By RM")
      });
    return dt;
  }
  
  async getBookingUnit(unitID) {
    let dt: any;
    await http.getDataParam("/booking", {
      params: { 
        bed_id: unitID,
      },
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Pemesanan Unit")
      });
    return dt;
  }
  
  async deleteBooking(id,pegawaiID) {
    let dt: any;
    await http.deleteData(`/booking/${id}/delete/pegawai_id/${pegawaiID}`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Hapus Pemesanan")
      });
    return dt;
  }
  
  async putCatatanBooking(id, catatan) {
    let dt: any;
    await http.putData(`/booking/${id}/catatan`, {
      catatan: catatan,
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Edit catatan booking")
      });
    return dt;
  }

  async postPasien(id,rm,diagnosa,unitAsal,dpjp,reg,pegawaiID,catatanPasien) {
    let dt: any;
    await http.postData(`/pasien-in/bed/${id}`, {
      rm: rm,
      diagnosa: diagnosa,
      unit_asal: unitAsal,
      dokter_id: dpjp,
      register: reg,
      pegawai_id: pegawaiID,
      catatan_pasien: catatanPasien
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Input Pasien")
      });
    return dt;
  }

  async batalMondok(id,unitAsal,pegawaiID) {
    let dt: any;
    await http.postData(`/pasien-in-cancel/bed/${id}`, {
      unit_asal: unitAsal,
      pegawai_id: pegawaiID,
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Batal Mondok")
      });
    return dt;
  }

  async pulangPasien(rm,pegawaiID) {
    let dt: any;
    await http.postData(`/pasien-out/rm/${rm}`, {
      pegawai_id: pegawaiID,
    })
    // await http.postDataNoParam(`/pasien-out/rm/${rm}`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Pulangkan Pasien")
      });
    return dt;
  }
  
  async mutasiPasien(rm,bedAsal,bedTujuan,pegawaiID,catatanPasien) {
    let dt: any;
    await http.postData(`/pasien-mutasi/rm/${rm}`, {
      bed_asal: bedAsal,
      bed_tujuan: bedTujuan,
      pegawai_id: pegawaiID,
      catatan_pasien: catatanPasien
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Mutasi Pasien")
      });
    return dt;
  }
  
  async editDiagnosa(id,diagnosa,pegawaiID) {
    let dt: any;
    await http.putData(`/bed/${id}/diagnosa`, {
      diagnosa: diagnosa,
      pegawai_id: pegawaiID,
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Edit Diagnosa")
      });
    return dt;
  }
  
  async getPasienByRM(rm) {
    let dt: any;
    await http.getData(`/pasien/${rm}`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Pasien By RM")
      });
    return dt;
  }
  
  async getRoleUser(id) {
    let dt: any;
    await http.getData(`/user/${id}/role`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Role User")
      });
    return dt;
  }
}

export default new DataBed();
